export default {
  PORTAL: 'portalTz',
  USER: 'userTz',
  USER_OBJECT: 'userObjectTz',
  UTC: 'utc'
};